import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { useLocale } from 'next-intl';
import type { MouseEvent } from 'react';

import { EventType } from '@/analytics/types';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import ArticleCardsDesktop from './ArticleCardsDesktop';
import ArticleCardsMobile from './ArticleCardsMobile';

const ARTICLE_CLASS_NAME = 'w-[75vw] bg-sandstone-400 md:w-[60vw] lg:w-full';
const HEADING_CLASS_NAME = 'text-xl';

const getArticleCards = (localePartialUrl: string): ArticleCardDataProps[] => [
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'MDPI',
      external: true,
      href: 'https://www.mdpi.com/1424-8220/21/13/4302',
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'science_research_2025_study_one',
    headingClassName: HEADING_CLASS_NAME,
  },
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'Oura',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}oura-ovulation-detection-algorithm-validation-study/`,
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'science_research_2025_study_two',
    headingClassName: HEADING_CLASS_NAME,
  },
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'Oura',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}how-accurate-is-oura/`,
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'science_research_2025_study_three',
    headingClassName: HEADING_CLASS_NAME,
  },
];

const ValidationSection = () => {
  const locale = useLocale();
  const articleCards = getArticleCards(getLocalePartialUrl(locale));

  const handleClick = async (
    event: MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    event.preventDefault();
    const target = event.currentTarget;
    const path = target.getAttribute('href');
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'view',
      location: 'body',
      path,
    });
    window.open(path!, '_blank');
  };

  return (
    <section className="pt-20 lg:pt-32" data-cy="validation-section">
      <LandingPageBlurb
        description={{
          alignment: 'top',
          className: 'text-xl',
          colStart: { lg: 15 },
          key: 'science_research_2025_validation_description',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'science_research_2025_validation_title',
          multiline: true,
        }}
      />
      <LayoutGrid className="pt-14 lg:py-20">
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'full', lg: 'main' }}>
          <ArticleCardsMobile
            articleCards={articleCards}
            onClick={handleClick}
          />
          <ArticleCardsDesktop
            articleCards={articleCards}
            onClick={handleClick}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ValidationSection;
